import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
	override format(date: Date, displayFormat: Object): string {
		const formatString = 'yyyy-MM-dd';
		const [day, month, year] = [
			date.getDate(),
			date.getMonth() + 1,
			date.getFullYear(),
		];
		return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
	}
}
